import { render, staticRenderFns } from "./sharePop.vue?vue&type=template&id=65867ca1&scoped=true&"
import script from "./sharePop.vue?vue&type=script&lang=js&"
export * from "./sharePop.vue?vue&type=script&lang=js&"
import style0 from "./sharePop.vue?vue&type=style&index=0&id=65867ca1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65867ca1",
  null
  
)

export default component.exports